export default __webpack_public_path__ + "015231c.png";